export const ANALYSIS_LIST = "ANALYSIS_LIST";
export const ANALYSIS_TYPE_LIST = "ANALYSIS_TYPE_LIST";
